module.exports = __webpack_public_path__ + "static/fonts/iconfont.7adc8ca6.ttf";